export enum MouldEnum {
	Square = 1,
	SquareTapering = 2,
	SquareOvoid = 3,
	Tapering = 4,
	TaperingOvoid = 5,
	Ovoid = 6,
	SquareTaperingOvoid = 7
}